import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule,  FormControl, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTab, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
 

import { BibleBookComponent } from './components/bible-book/bible-book.component';
import { BibleBookEditComponent } from './components/bible-book-edit/bible-book-edit.component';
import { IndexComponent } from './components/index/index.component';
import { LanguageComponent } from './components/language/language.component';
import { LanguageEditComponent } from './components/language-edit/language-edit.component';
import { ReligionBranchTypeComponent } from './components/religion-branch-type/religion-branch-type.component';
import { ReligionBranchComponent } from './components/religion-branch/religion-branch.component';
import { ReligionBranchEditComponent } from './components/religion-branch-edit/religion-branch-edit.component';
import { VestmentColorComponent } from './components/vestment-color/vestment-color.component';
import { ProperComponent } from './components/proper/proper.component'; 
import { SeasonComponent } from './components/season/season.component';
import { LiturgyTypeComponent } from './components/liturgy-type/liturgy-type.component';
import { UserManagementComponent } from "./components/user-management/user-management.component";

import { AdminRoutingModule } from './admin.routing.module';
import { LanguageStyleComponent } from 'app/modules/admin/components/language-style/language-style.component';
import { LectionaryItemComponent } from 'app/modules/admin/components/lectionary-item/lectionary-item.component';
import { LectionaryItemTypeComponent } from 'app/modules/admin/components/lectionary-item-type/lectionary-item-type.component';
import { LectionarySourceComponent } from 'app/modules/admin/components/lectionary-source/lectionary-source.component';
import { LectionaryTrackComponent } from 'app/modules/admin/components/lectionary-track/lectionary-track.component';
import { LectionaryYearComponent } from 'app/modules/admin/components/lectionary-year/lectionary-year.component';
import { ServiceDateTypeComponent } from 'app/modules/admin/components/service-date-type/service-date-type.component';
import { ServiceComponent } from 'app/modules/admin/components/service/service.component'; 

import { EditUserComponent } from 'app/modules/admin/components/edit-user/edit-user.component';
import {LectionaryItemNameComponent } from 'app/modules/admin/components/lectionary-item-name/lectionary-item-name.component';
import { LanguageService } from './services/language.service';
import { BibleBookService } from './services/bible-book.service';
import { LectionaryItemTypeEditComponent } from './components/lectionary-item-type-edit/lectionary-item-type-edit.component';
import { LectionaryItemTypeDetailComponent } from './components/lectionary-item-type-detail/lectionary-item-type-detail.component';
import { LectionaryItemEditComponent } from './components/lectionary-item-edit/lectionary-item-edit.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { LectionarySourceService } from './services/lectionary-source.service';
import { LanguageStyleService } from './services/language-style.service';
import { LectionaryItemNameService } from './services/lectionary-item-name.service';
import { LectionaryItemTypeService } from './services/lectionary-item-type.service';
import { LectionaryItemService } from './services/lectionary-item.service';
import { LectionaryItemNameEditComponent } from './components/lectionary-item-name-edit/lectionary-item-name-edit.component';
import { ReligionBranchServiceService } from './services/religion-branch.service';
import { LectionarySourceEditComponent } from './components/lectionary-source-edit/lectionary-source-edit.component';
import { LectionaryYearEditComponent } from './components/lectionary-year-edit/lectionary-year-edit.component';
import { LectionaryTrackEditComponent } from './components/lectionary-track-edit/lectionary-track-edit.component';
import { LectionaryTrackService } from './services/lectionary-track.service';
import { LectionaryYearService } from './services/lectionary-year.service';
import { SeasonEditComponent } from './components/season-edit/season-edit.component';
import { VestmentColorEditComponent } from './components/vestment-color-edit/vestment-color-edit.component';
import { SeasonService } from './services/season.service';
import { ServiceService } from './services/service.service';
import { VestmentColorService } from './services/vestment-color.service';
import { ServiceEditComponent } from './components/service-edit/service-edit.component';
import { ServiceDateTypeService } from './services/service-date-type.service';
import { ServiceTypeService } from './services/service-type.service';
import { LiturgyTypeService } from './services/liturgy-type.service';
import { FeastTypeService } from './services/feast-type.service';
import { MappingsComponent } from './components/mappings/mappings.component';
import { MappingsService } from './services/mappings.service';
import { ProperEditComponent } from './components/proper-edit/proper-edit.component';
import { FeastTypeComponent } from './components/feast-type/feast-type.component';
import { ServiceFilterPipe } from 'app/pipes/service-filter.pipe';  
import { LectionaryItemSearchFilter } from 'app/pipes/lectionary-item-search-filter.pipe';
import { ServiceEditRelatedServiceLookupComponent } from './components/service-edit-related-service-lookup/service-edit-related-service-lookup.component';
//import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CalendarItemComponent } from './components/calendar-item/calendar-item.component';
import { CalendarItemEditComponent } from './components/calendar-item-edit/calendar-item-edit.component';
import { CalendarItemService } from './services/calendar-item.service';
import { CalendarItemEditUrlsComponent } from './components/calendar-item-edit-urls/calendar-item-edit-urls.component';
import { CalendarItemEditUrlsDetailComponent } from './components/calendar-item-edit-urls-detail/calendar-item-edit-urls-detail.component';
import { CalendarItemHyperlinkService } from './services/calendar-item-hyperlink.service';
import { CalendarItemEditRelatedServicesComponent } from './components/calendar-item-edit-related-services/calendar-item-edit-related-services.component';
import { CalendarItemEditRelatedServicesIndividualComponent } from './components/calendar-item-edit-related-services-individual/calendar-item-edit-related-services-individual.component';
import { CssComponent } from './components/css/css.component';
import { CssService } from './services/css.service';
import { DisplayMatchingPronunciatonsComponent } from './components/display-matching-pronunciatons/display-matching-pronunciatons.component';
import { LectionaryItemHtmlEditorComponent } from './components/lectionary-item-html-editor/lectionary-item-html-editor.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { LectionaryItemSearchComponent } from './components/lectionary-item-search/lectionary-item-search.component';
import { PsalterComponent } from './components/psalter/psalter.component';
import { PronunciationComponent } from './components/pronunciation/pronunciation.component';
import { PronunciationEditComponent } from './components/pronunciation-edit/pronunciation-edit.component';
import { PsalterEditComponent } from './components/psalter-edit/psalter-edit.component';
import { PsalterSearchComponent } from './components/psalter-search/psalter-search.component';
import { PsalterFilterPipe } from 'app/pipes/psalter-filter.pipe';
import { LectionaryItemNameValidateComponent } from './components/lectionary-item-name-validate/lectionary-item-name-validate.component';
import { MappingsEditComponent } from './components/mappings-edit/mappings-edit.component';
import { MappingFilterPipe } from 'app/pipes/mapping-filter.pipe';
import { ClearCacheComponent } from './components/clear-cache/clear-cache.component';
import { LiturgyTypeLectionaryItemTypeDisplayOrderComponent } from './components/liturgy-type-lectionary-item-type-display-order/liturgy-type-lectionary-item-type-display-order.component';
import { LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent } from './components/liturgy-type-lectionary-item-type-display-order-edit/liturgy-type-lectionary-item-type-display-order-edit.component';
import { LectionaryItemNameEditShowMappingsComponent } from './components/lectionary-item-name-edit-show-mappings/lectionary-item-name-edit-show-mappings.component';
import { LectionaryItemNameEditShowItemsComponent } from './components/lectionary-item-name-edit-show-items/lectionary-item-name-edit-show-items.component';
import { ServiceSearchComponent } from './components/service-search/service-search.component';
import { ServiceEditViewAvailablePropersComponent } from './components/service-edit-view-available-propers/service-edit-view-available-propers.component';
import { ProperFilterPipe } from 'app/pipes/proper-filter.pipe'; 
import { PronunciationFilterPipe } from 'app/pipes/pronunciation-filter.pipe';
import { SharedModule } from '../shared/shared.module';
import { ProperService } from './services/proper.service';
import { PronunciationService } from './services/pronunciation.service';
 
@NgModule({
  imports: [
    AdminRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    FormsModule,
    HttpClientModule, 
    ReactiveFormsModule, 
    CodemirrorModule,
    NgxPaginationModule, 
    SharedModule
  ],
  exports: [ 
  ],
  declarations: [
    IndexComponent,
    BibleBookComponent,
    BibleBookEditComponent,
    CalendarItemComponent,
    CalendarItemEditComponent,
    CalendarItemEditUrlsComponent,
    CalendarItemEditUrlsDetailComponent,
    CalendarItemEditRelatedServicesComponent,
    CalendarItemEditRelatedServicesIndividualComponent,
    CssComponent, 
    DisplayMatchingPronunciatonsComponent,
    LanguageStyleComponent,
    LectionaryItemComponent,
    LectionaryItemEditComponent,
    LectionaryItemSearchComponent,
    LectionaryItemTypeComponent,
    LectionaryItemTypeEditComponent,
    LectionaryItemTypeDetailComponent,
    LectionaryItemNameComponent,
    LectionaryItemNameEditComponent,
    LectionaryItemNameEditShowMappingsComponent,
    LectionaryItemNameEditShowItemsComponent,
    LectionaryItemHtmlEditorComponent,
    LectionarySourceComponent,
    LectionaryTrackComponent,
    LectionaryYearComponent,
    LectionarySourceEditComponent,
    LectionaryItemNameValidateComponent,
    LiturgyTypeLectionaryItemTypeDisplayOrderComponent,
    LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent,
    LanguageComponent,
    FeastTypeComponent,
    ReligionBranchComponent,
    ReligionBranchEditComponent,
    ReligionBranchTypeComponent,
    VestmentColorComponent,
    LanguageEditComponent,
    PsalterComponent,
    PsalterEditComponent, 
    PsalterSearchComponent, 
    ProperComponent, 
    PronunciationComponent,
    PronunciationEditComponent,
    ProperEditComponent,
    SeasonComponent,
    ServiceComponent,
    ServiceSearchComponent,
    ServiceEditRelatedServiceLookupComponent,
    ServiceDateTypeComponent,  
    LiturgyTypeComponent,
    UserManagementComponent,
    EditUserComponent, 
    ModalHeaderComponent,
    MappingsComponent,
    MappingsEditComponent,
    LectionaryTrackEditComponent,
    LectionaryYearEditComponent,
    SeasonEditComponent,
     ServiceEditComponent,
     ServiceEditViewAvailablePropersComponent,
     VestmentColorEditComponent, 
     LectionaryItemSearchFilter,
     ServiceFilterPipe,
     ProperFilterPipe,
     PronunciationFilterPipe,
     ClearCacheComponent,
     PsalterFilterPipe,
     MappingFilterPipe,
  ],
  providers: [
    CalendarItemService,
    CalendarItemHyperlinkService,
    CssService,
    LanguageService,
    LectionaryItemService,
    LectionaryItemNameService,
    LectionaryItemTypeService,
    LectionarySourceService,
    LanguageStyleService,
    BibleBookService,
    ReligionBranchServiceService,
    LectionaryTrackService,
    LectionaryYearService,
    SeasonService,
    ServiceService,
    ServiceDateTypeService,
    ServiceTypeService,
    LiturgyTypeService,
    VestmentColorService,
    FeastTypeService,
    MappingsService,
    ProperService,
    PronunciationService
  ],
  entryComponents: [
    BibleBookEditComponent,
    CalendarItemEditComponent,
    LanguageEditComponent,
    LectionaryItemEditComponent,
    LectionaryItemTypeEditComponent,
    LectionaryItemNameEditComponent,
    LectionarySourceEditComponent,
    LectionaryTrackEditComponent,
    LectionaryYearEditComponent,
    LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent,
    PsalterEditComponent,
    ReligionBranchEditComponent,
    EditUserComponent,
    SeasonEditComponent, 
    ServiceEditComponent,
    ProperEditComponent,
    VestmentColorEditComponent,
    ServiceEditComponent
  ],
})
export class AdminModule { }
